import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { enqueueSnackbar } from 'notistack';
import {
  Box,
  CircularProgress,
  Typography,
  Card,
  CardContent,
  Divider,
  List,
  ListItem,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ShowFormStatus = () => {
  const [workflows, setWorkflows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('token');
  const { userId } = jwtDecode(token);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWorkflows = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/active-workflows/filled-by/${userId}`
        );
        setWorkflows(response.data.workflows);
        setLoading(false);
      } catch (err) {
        setError('Failed to load workflows');
        setLoading(false);
        enqueueSnackbar('Failed to load forms', { variant: 'error' });
      }
    };

    fetchWorkflows();
  }, [userId]);

  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '100%',
        mx: 'auto',
        p: 3,
      }}
    >
      <Typography variant="h5" gutterBottom>
        Form Status
      </Typography>

      {workflows.length > 0 ? (
        <List sx={{ width: '100%', maxWidth: 900 }}>
          {workflows.map((workflow) => (
            <ListItem
              key={workflow._id}
              sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}
            >
              <Card sx={{ width: '100%', maxWidth: 900, boxShadow: 3 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Form Data
                  </Typography>
                  {workflow.formData.map((field) => (
                    <Box key={field.fieldName} sx={{ mb: 1 }}>
                      <Typography variant="body1" color="textPrimary">
                        <strong>{field.fieldName}:</strong>{' '}
                        {Array.isArray(field.value)
                          ? field.value.join(', ')
                          : field.value}
                      </Typography>
                    </Box>
                  ))}

                  <Divider sx={{ my: 2 }} />

                  <Typography variant="body1">
                    <strong>Status:</strong> {workflow.status}
                  </Typography>

                  <Box sx={{ mt: 3, textAlign: 'right' }}>
                    <Button
                      variant="outlined"
                      onClick={() =>
                        navigate(`${workflow._id}`)
                      }
                    >
                      Show Flow
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography>No active workflows found.</Typography>
      )}
    </Box>
  );
};

export default ShowFormStatus;
